export default class AiVideoMetadataReader
{

	constructor()
	{
		
	}

	read(fileObject)
	{
		const c = this;

		c.video = document.createElement('video')
		c.video.o = c;
		c.video.addEventListener('loadedmetadata', c.onMetadataLoaded);
		c.video.addEventListener('error', c.onVideoLoadError);
		c.video.src = URL.createObjectURL(fileObject);

		return new Promise((resolve, reject) =>
		{
			c.fsResolve = resolve;
			c.fsReject = reject;
		});
	}

	onMetadataLoaded()
	{
		const c = this.o;
		c.removeListeners();
		c.fsResolve(c.video);
	}

	onVideoLoadError(er)
	{
		const c = this.o;
		c.removeListeners();
		c.fsReject('AiVideoMetadataReader: Error reading video file src.', er);
	}

	removeListeners()
	{
		const c = this;
		c.video.removeEventListener('loadedmetadata', c.onMetadataLoaded)
		c.video.removeEventListener('error', c.onVideoLoadError);
	}

	


}